/**
 * 플랫폼 사용자 목록 엑셀.
 * 식별·연락처 → 업체/면허 → 정산 계좌 순으로 내려보낸다.
 */
import type {
  PlatformUserResponse,
  PlatformUserSearchRequest,
} from '@/entities/user/api/user.api';
import { userService } from '@/entities/user/api/user.api';
import { formatPhoneNumber, getUserRowId } from '@/pages/users/userListUtils';
import { fetchAllPagedItems } from '@/shared/utils/fetchAllPagedItems';
import { downloadXlsx } from '@/shared/utils/xlsxExport';

/** 엑셀 컬럼 순서는 객체 삽입 순서를 따른다 */
export const USER_LIST_HEADER_MAP: Record<string, string> = {
  userId: '유저 ID',
  email: '사용자 이메일',
  phoneNumber: '전화번호',
  address: '주소',
  companyName: '업체명',
  ceoName: '대표자명',
  businessLicenseNumber: '사업자등록번호',
  promoLicenseNumber: '판촉영업자신고번호',
  bankName: '금융기관',
  bankAccountNumber: '계좌번호',
  taxInvoiceEmail: '세금계산서 이메일',
};

export const mapUsersForExport = (
  users: PlatformUserResponse[],
): Record<string, unknown>[] =>
  users.map((user) => ({
    userId: getUserRowId(user),
    email: user.email || '',
    phoneNumber: formatPhoneNumber(user.phoneNumber),
    address: user.address || '',
    companyName: user.companyName || '',
    ceoName: user.ceoName || '',
    businessLicenseNumber: user.businessLicenseNumber || '',
    promoLicenseNumber: user.promoLicenseNumber || '',
    bankName: user.bankName || '',
    bankAccountNumber: user.bankAccountNumber || '',
    taxInvoiceEmail: user.taxInvoiceEmail || '',
  }));

export const downloadUserListExcel = async (
  search: PlatformUserSearchRequest,
): Promise<number> => {
  const users = await fetchAllPagedItems((page, size) =>
    userService.getUsers(search, { page, size }),
  );
  if (users.length === 0) {
    throw new Error('다운로드할 사용자가 없습니다.');
  }
  downloadXlsx(mapUsersForExport(users), '사용자_목록', USER_LIST_HEADER_MAP);
  return users.length;
};
